import type { OrderItem } from '@octave/contracts';

interface AccessoryItemMetadataProps {
  item: OrderItem;
}

export function AccessoryItemMetadata({ item }: AccessoryItemMetadataProps) {
  const { metadata } = item;

  if (metadata.type !== 'ACCESSORY') {
    return null;
  }

  return (
    <div className="mt-2 space-y-2">
      <div className="text-xs text-slate-500">
        {metadata.category && <div>Catégorie: {metadata.category}</div>}
        {metadata.name && <div>Nom: {metadata.name}</div>}
      </div>

      {metadata.color && (
        <div className="mt-2">
          <span className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold bg-slate-100 text-slate-600">
            Couleur: {metadata.color}
          </span>
        </div>
      )}

      {metadata.compatibleDeviceBrand && metadata.compatibleDeviceModel && (
        <div className="mt-2">
          <span className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold bg-amber-50 text-amber-700">
            Compatible {metadata.compatibleDeviceBrand}{' '}
            {metadata.compatibleDeviceModel}
          </span>
        </div>
      )}
    </div>
  );
}
